import { DocumentStatusOption } from '../constants'

const defaultOptionLabels = {
  [DocumentStatusOption.empty]: 'No document uploaded',
  [DocumentStatusOption.pending_review]: 'Pending review',
  [DocumentStatusOption.conditionally_approved]: 'Conditionally approved',
  [DocumentStatusOption.rejected]: 'Rejected',
  [DocumentStatusOption.approve_and_commit]: 'Approved and committed',
  [DocumentStatusOption.move_to_archived]: 'Move to archived',
  [DocumentStatusOption.un_archive]: 'Unarchive',
  [DocumentStatusOption.not_required]: 'Not required',
  [DocumentStatusOption.esign_requested]: 'eSign requested',
}

export function getShallowStatus(document) {
  const { status, files } = document

  if (status === DocumentStatusOption.pending_review && files.length === 0)
    return DocumentStatusOption.empty

  return status
}

const filterOut = (array, value) =>
  array.filter((arrayValue) => arrayValue !== value)

export function getSelectOptions({
  document,
  customerService,
  resourceType,
  preventMarkAsNotRequired,
}) {
  const { skippable, status, type, uploaded, canBeManuallyArchived, files } =
    document
  const isCustom = type === 'Document::Custom'
  const isArchivable = isCustom ? true : canBeManuallyArchived
  const isArchived = resourceType === 'Archived'

  let options = Object.values(DocumentStatusOption)

  // remove empty option
  options = filterOut(options, DocumentStatusOption.empty)

  // remove archive-unarchive options if...
  if (!customerService || !isArchivable) {
    options = filterOut(options, DocumentStatusOption.move_to_archived)
    options = filterOut(options, DocumentStatusOption.un_archive)
  }

  // remove archive option if...
  if (isArchived)
    options = filterOut(options, DocumentStatusOption.move_to_archived)

  // remove unarchive option if...
  if (!isArchived) options = filterOut(options, DocumentStatusOption.un_archive)

  // remove esign_requested option unless it is the current status
  if (status !== DocumentStatusOption.esign_requested)
    options = filterOut(options, DocumentStatusOption.esign_requested)

  // remove approve_and_commit option if...
  if (!uploaded && skippable)
    options = filterOut(options, DocumentStatusOption.approve_and_commit)

  if (preventMarkAsNotRequired)
    options = filterOut(options, DocumentStatusOption.not_required)

  const shallowStatus = getShallowStatus(document)

  // empty buckets should show only the not_required option
  if (shallowStatus === DocumentStatusOption.empty)
    options = preventMarkAsNotRequired
      ? []
      : [DocumentStatusOption.not_required]

  // not_required-empty buckets should show only the pending_review option
  if (shallowStatus === DocumentStatusOption.not_required && files.length === 0)
    options = [DocumentStatusOption.pending_review]

  // add existing shallow status to the top of the list
  if (!options.includes(shallowStatus)) options.unshift(shallowStatus)

  return options.map((option) => ({
    option,
    label: defaultOptionLabels[option],
  }))
}

export function getIsSelectEnabled({
  document,
  superUser,
  bankAdmin,
  bankProcessor,
}) {
  const { status } = document

  // only certain users can change status if it is approve and commit
  if (
    status === DocumentStatusOption.approve_and_commit &&
    ![superUser, bankAdmin, bankProcessor].some(Boolean)
  )
    return false

  return true
}
